import { FaGithub } from "react-icons/fa";
import { motion } from "framer-motion";

export default function Footer() {
  const iconVariants = {
    hover: { y: -5, scale: 1.2 },
  };

  return (
    <footer className="bg-gray-900 text-white py-10 px-4 relative">
      <div className="max-w-6xl mx-auto flex items-center justify-between relative">
        {/* Logo */}
        <div className="flex-shrink-0">
          <img
            src="/images/krtlogowhite.png"
            alt="Krittonics Logo"
            className="h-12 w-auto"
          />
        </div>

        {/* Copyright */}
        <div className="text-gray-500 text-sm">
          &copy; {new Date().getFullYear()} Krittonics by TONMAII. All rights
          reserved.
        </div>
      </div>
    </footer>
  );
}
